import classnames from 'classnames';
import { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import useSchoolBlocksApi from '../hooks/useSchoolBlocksApi';
import { OrganizationController } from "../../backends/YiiRoutes";
import NotificationManager from "../notifications/NotificationManager";
import {StoreContext} from "../../stores/StoreLoader";
import styles from "../../pages/styles/MainGridPage.module.scss";


export function ToggleOrganizationPrivacyContainer(props) {
    const { isEditable, orgId, orgType } = props;
    const {i18nStore} = useContext(StoreContext);

    const [ isPrivate, setIsPrivate ] = useState(props.isPrivate || false);
    const [{ result, isLoading, isError }, setApiParameters] = useSchoolBlocksApi();

    // When the API result changes, this effect gets called
    useEffect(() => {
        if (result.status === 200) {
            // The API succeeded!  Now change the local state that triggers a re-render
            const newIsPrivate = !isPrivate;
            setIsPrivate(newIsPrivate);
            NotificationManager.success(`This ${orgType} is now ${newIsPrivate ? 'private' : 'public'}`);
        } else if (isError) {
            // The API failed
            NotificationManager.error('You have no permissions to change access.');
        }
    }, [result]);

    // This is the onClick function for the button when editing.  It calls the API
    const togglePrivacy = () => {
        let route = orgType;
        if (route === 'department') {
            route = 'group';
        }
        // call the SchoolBlocksApi by setting the API parameters
        setApiParameters({
            url: OrganizationController.fluidAccess(i18nStore.currentOrgSupportedLocale, route, orgId),
            method: 'POST',
            data: {
                lock: !isPrivate, // toggle the current setting
            },
        });
    };

    if (isLoading) {
        NotificationManager.info('Saving new settings, please wait.');
    }

    const padlockClass = classnames({
        'fa': true,
        'fa-lock': isPrivate,
        'fa-unlock-alt': !isPrivate,
    });

    const padlockText = `This is a ${isPrivate ? 'private' : 'public'} ${orgType}.  Click to make ${isPrivate ? 'public' : 'private'}`;
    const padlockTag = <span className={padlockClass} title={padlockText} style={{fontSize: '1.3em'}} />;

    let button = null;
    if (isEditable) {
        button = <button onClick={togglePrivacy} className="section-access-button sb-organization-color-element-font">
            {padlockTag}
            <div className={styles.hiddenWhenSmall}>{isPrivate ? "Unlock" : "Lock"}</div>
        </button>;
    } else if (isPrivate) {
        button = padlockTag;
    }

    return button;
}
ToggleOrganizationPrivacyContainer.propTypes = {
    isEditable: PropTypes.bool,
    isPrivate: PropTypes.bool,
    orgId: PropTypes.string.isRequired,
    orgType: PropTypes.string.isRequired,
};
